import type { ReactNode } from 'react'
import React from 'react'

import LoadingImg from '@/assets/data-loading.png'

interface DataLoadingProps {
  loading: boolean
  children?: ReactNode
}

const DataLoading: React.FC<DataLoadingProps> = ({ loading, children }) => {
  if (loading) {
    return (
      <div className="w-full">
        <img src={LoadingImg} alt="loading" width={150} />
      </div>
    )
  }
  return <div className="w-full">{children}</div>
}

export default DataLoading
